import { createSlice } from "@reduxjs/toolkit"
import types from "../../Actions/types"

const initialState = {
	isLoading: true,
	isLoadingWorkshops: false,
	isLoadingActivities: false,
	isLoadingworkshopEvents: false,
	hasError: false,
	attendees: [],
	workshops: [],
	activities: [],
	workshopEvents: [],
	programCoordinator: null
}

const workshopSlice = createSlice({
	name: "workshop",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(types.SET_WORKSHOPS, (state, action) => {
			const workshops = action.payload
			if (!workshops || !workshops.length) {
				return { ...initialState }
			}
			state.workshops = workshops
			state.isLoadingWorkshops = false
		})
		builder.addCase(types.SET_LOADING, (state, action) => {
			state.isLoadingWorkshops = action.payload
		})
		builder.addCase(types.SET_ERROR, (state) => {
			state.hasError = true
		})
		builder.addCase(types.FETCHING_ATTENDEES, (state) => {
			state.isLoading = true
			state.hasError = false
		})
		builder.addCase(types.FETCHED_ATTENDEES, (state, action) => {
			state.attendees = action.data
			state.isLoading = false
			state.hasError = false
			state.programCoordinator = action.programCoordinator
		})
		builder.addCase(types.FETCH_ATTENDEES_ERROR, (state) => {
			state.hasError = true
			state.isLoading = false
		})
		builder.addCase(types.FETCHING_ACTIVITIES, (state) => {
			state.isLoadingActivities = true
		})
		builder.addCase(types.FETCHED_ACTIVITIES, (state, action) => {
			state.activities = action.data
			state.isLoadingActivities = false
		})
		builder.addCase(types.FETCH_ACTIVITIES_ERROR, (state) => {
			state.hasError = true
			state.isLoadingActivities = false
		})
		builder.addCase(types.FETCHING_WORKSHOP_EVENTS, (state) => {
			state.isLoadingworkshopEvents = true
		})
		builder.addCase(types.FETCHED_WORKSHOP_EVENTS, (state, action) => {
			state.workshopEvents = action.data
			state.isLoadingworkshopEvents = false
		})
		builder.addCase(types.FETCH_WORKSHOP_EVENTS_ERROR, (state) => {
			state.hasError = true
			state.isLoadingworkshopEvents = false
		})
		builder.addCase(types.UPDATE_USER_ACTIVITY_STATUSES, (state, action) => {
			const activityStatus = action.payload
			state.activities = state.activities.map((activity) => {
				if (activity.id === activityStatus.activity_id) {
					const updated = { ...activity }
					updated.userActivityStatuses = {
						...activityStatus,
						completed: activityStatus.completed === 1
					}
					return updated
				}
				return activity
			})
		})
		builder.addCase(types.LOGOUT, () => ({ ...initialState }))
	}
})

export default workshopSlice.reducer
